{
  "views": {
    "front": "Front",
    "back": "Back",
    "corner_tl": "Top-left corner",
    "corner_tr": "Top-right corner",
    "corner_bl": "Bottom-left corner",
    "corner_br": "Bottom-right corner",
    "label": "Grading label",
    "zoom": "Close-up",
    "surface": "Surface in the light",
    "edge": "Edge"
  },
  "views_hint": {
    "front": "Put the whole card inside the frame, front up",
    "back": "Turn the card over — whole back inside the frame",
    "corner_tl": "Close to the top-left corner",
    "corner_tr": "Close to the top-right corner",
    "corner_bl": "Close to the bottom-left corner",
    "corner_br": "Close to the bottom-right corner",
    "label": "The grading label with the certificate number",
    "zoom": "Any mark or detail buyers should see",
    "surface": "Tilt the card so the light shows scratches",
    "edge": "One side of the card or the case"
  },
  "camera": {
    "step": "Photo {{n}} of {{count}}: {{name}}",
    "title": "Camera",
    "close": "Close the camera",
    "denied": "The camera is blocked. Allow the camera for this site in the browser settings, or use “Choose pictures”.",
    "unavailable": "No camera found on this device. Use “Choose pictures” instead.",
    "retake": "Take again",
    "shoot": "Take the photo",
    "skip": "Skip"
  },
  "gallery": {
    "edit_alt": "Edit the description",
    "alt_title": "Picture description",
    "alt_hint": "Read out to blind customers and used by search engines.",
    "alt_en": "English",
    "alt_th": "Thai",
    "alt_save": "Save",
    "picture_n": "Picture {{n}} of {{count}}",
    "sortable": "movable picture",
    "main": "Main",
    "move_earlier": "Move {{name}} earlier",
    "move_later": "Move {{name}} later",
    "make_main": "Make {{name}} the main picture",
    "remove": "Remove {{name}}",
    "moved": "Picture {{from}} is now number {{to}} of {{count}}",
    "removed": "Picture {{n}} removed",
    "keys_hint": "Arrow keys move the picture, Home makes it the main picture, Delete removes it.",
    "removed_toast": "Picture removed",
    "alt_failed": "The description could not be saved — try again"
  },
  "uploader": {
    "progress": "Uploading {{name}}",
    "heic_note": "iPhone photo (HEIC): it is converted after the upload.",
    "retry": "Try again",
    "cancel": "Stop uploading {{name}}",
    "dismiss": "Remove {{name}} from the list",
    "too_many": "Only {{max}} pictures fit — {{left}} were not added.",
    "camera_step": "Take photo: {{name}} ({{n}}/{{count}})",
    "camera": "Take photos",
    "camera_one": "Take a photo",
    "count": "{{count}} of {{max}} pictures",
    "remove_file": "Remove",
    "no_photos": "No pictures yet — add at least the front before putting it on sale.",
    "in_progress": "Files on the way",
    "drop_zone": "Add pictures: drop files here, paste, or use the buttons",
    "secure_note": "Stored encrypted — only staff with permission can open it.",
    "drop_hint_many": "Drop pictures here, paste them, or use the buttons. They upload by themselves.",
    "drop_hint_one": "Drop the file here, paste it, or use the buttons.",
    "choose_many": "Choose pictures",
    "choose_one": "Choose a file",
    "pick_existing": "Use uploaded pictures",
    "skip_step": "Skip this photo",
    "full": "All {{max}} places are used. Remove a picture to add another.",
    "busy_one": "{{count}} file still uploading…",
    "busy_other": "{{count}} files still uploading…"
  },
  "status": {
    "preparing": "Getting ready…",
    "waiting": "Waiting…",
    "uploading": "Uploading…",
    "processing": "Almost done…",
    "offline": "No internet — continues by itself",
    "ready": "Done",
    "failed": "Did not upload",
    "rejected": "Not accepted",
    "cancelled": "Stopped"
  },
  "problem": {
    "not_image": "This file is not a picture.",
    "type": "This kind of file cannot be used here. Use a JPEG, PNG, WebP or iPhone photo.",
    "too_large": "The file is too large.",
    "empty": "The file is empty.",
    "size_mismatch": "The file changed while uploading — try again.",
    "corrupt_file": "The file is damaged and cannot be opened.",
    "processing_failed": "The picture could not be prepared — upload it again.",
    "processing_timeout": "This takes longer than usual. It may still appear — or try again.",
    "network_error": "The connection broke. Try again.",
    "other": "This file could not be used."
  },
  "restricted": {
    "stored": "Stored securely",
    "alt": "Stored document",
    "error": "The file could not be opened. Try again, or ask a manager.",
    "hide": "Hide",
    "loading": "Opening…",
    "show": "Show",
    "note": "Opening it is recorded. The picture is not saved on this device."
  },
  "picker": {
    "title": "Uploaded pictures",
    "close": "Close",
    "search": "Search by name or description",
    "loading": "Loading…",
    "error": "The pictures could not be loaded.",
    "empty": "No pictures found.",
    "results": "Pictures",
    "picture": "Picture",
    "more": "Show more",
    "cancel": "Cancel",
    "add_one": "Add {{count}} picture",
    "add_other": "Add {{count}} pictures"
  }
}
